import { render, staticRenderFns } from "./participantsIndicator.vue?vue&type=template&id=d765aa30"
import script from "./participantsIndicator.vue?vue&type=script&lang=js"
export * from "./participantsIndicator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports